import { FC } from 'react';

import ReclassificationModalHeader from './components/ReclassificationModalHeader';
import ReclassificationModalBody from './components/ReclassificationModalBody';
import ReclassificationModalFooter from './components/ReclassificationModalFooter';

import { useReclassificationModal } from './context/ReclassificationModalContext';
import CustomLoading from '../../CustomLoading';

import '../Modals.scss';

const ReclassificationModal: FC = () => {
  const { data } = useReclassificationModal();

  const isLoading =
    data.isLoading ||
    (data.isLoadingRanges &&
      data.loadingKeys.length === 0 &&
      !data.scriptureView);

  return (
    <>
      <ReclassificationModalHeader />
      <ReclassificationModalBody />
      <ReclassificationModalFooter />

      {isLoading && <CustomLoading />}
    </>
  );
};

export default ReclassificationModal;
